export enum EngineVisibilityEnum {
    Hidden = -1,
    Shown = 1
}
